export default __webpack_public_path__ + "static/media/RoadService.caa3425a.jpg";